(() => {
    // slick default setting
    let defaultSettings = {
        loop: true,
        speed: 700,
        effect: "fade",
        fadeEffect: {
            crossFade: true
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    document.querySelectorAll(".swiper-slider").forEach(slider => {
        new Swiper(slider, Object.assign({}, defaultSettings, slider.dataset.swiper ? JSON.parse(slider.dataset.swiper) : {}));
    });

    const galleryThumbs = new Swiper('.swiper-gallery-thumbs', {
        loop: true,
        speed: 700,
        slidesPerView: 3,
        spaceBetween: 30,
        initialSlide: 1,
        allowTouchMove: false
    });

    const galleryMain = new Swiper('.swiper-gallery-main', {
        speed: 800,
        watchSlidesProgress: true,
        virtualTranslate: true,
        loop: true,
        navigation: {
            nextEl: '.swiper-gallery-thumbs-next',
            prevEl: '.swiper-gallery-thumbs-prev',
        },
        on: {
            init(swiper) {
                swiper.slides.forEach((slide) => {
                    slide.style.transitionProperty = 'transform, clip-path';
                    const progress = slide.progress;
                    const tx = -slide.swiperSlideOffset;
                    let clipRight = progress <= 0 ? Math.min(Math.abs(progress) * 100, 100) : 0;

                    slide.style.transform = `translateX(${tx}px)`;
                    slide.style.clipPath = `inset(0 0 0 ${clipRight}%)`;
                });
                void swiper.wrapperEl.offsetHeight;
            },

            setTranslate(swiper) {
                const { slides } = swiper;

                slides.forEach((slide) => {
                    const progress = slide.progress;

                    const tx = -slide.swiperSlideOffset;

                    let clipRight = 0;
                    let zIndex = 0;

                    if (progress <= 0) {
                        clipRight = Math.min(Math.abs(progress) * 100, 100);
                        zIndex = 2;
                    } else {
                        clipRight = 0;
                        zIndex = 1;
                    }

                    slide.style.transform = `translateX(${tx}px)`;
                    slide.style.zIndex = zIndex;
                    slide.style.clipPath = `inset(0 0 0 ${clipRight}%)`;
                });
            },

            setTransition(swiper, duration) {
                const { slides } = swiper;

                slides.forEach((slide) => {
                    slide.style.transitionDuration = `${duration}ms`;
                });

                if (duration !== 0) {
                    clearTimeout(swiper.customTimeout);

                    swiper.customTimeout = setTimeout(() => {
                        swiper.animating = false;
                        swiper.emit('transitionEnd');
                    }, duration);
                }
            },

            slideChange(swiper) {
                galleryThumbs.slideToLoop((swiper.realIndex + 1) % swiper.slides.length);
            }
        }
    });
})();